<script setup lang="ts">
import type { ArtistCredit } from '~/types'
import { useStore } from '~/store'
import { type WithAttributes, fw } from '~/ui/attributes'

import { to } from '~/routing'

import Token from '~/ui/Token.vue'
import Sync from '~/ui/Sync.vue'
import { useDataStore } from '~/data'

const store = useStore()

const props = defineProps<WithAttributes<{
  class: {
    justify?: 'justify-center'
  }
  artistCredit: ArtistCredit[]
}>>()
</script>

<template>
  <span :class="[fw.layout.row, props.class]">
    <template
      v-for="artistCredit in props.artistCredit"
      :key="artistCredit.artist.id"
    >
          <Token v-bind="{
            ...$attrs,
            ...to({ name: 'library.artists.detail', params: { id: artistCredit.artist.id }})
          }"
           ui-no-underline
           >
          <template #image>
            <Sync
              :use="() => useDataStore().get('artist', artistCredit.artist.id)"
              v-slot="{ state }"
            >
              <img
                    v-if="state.value?.cover && state.value?.cover.urls.small_square_crop"
                    v-lazy="store.getters['instance/absoluteUrl'](state.value.cover.urls.small_square_crop)"
                    :alt="state.value?.name"
              >
              <Icon
                v-else
                icon="bi:person-circle"
                size="24"
              />
            </Sync>
          </template>
          {{ artistCredit.credit }}
        </Token>
      <span>{{ artistCredit.joinphrase }}</span>
    </template>
  </span>
</template>
